import {Button} from 'antd';
import cn from 'classnames';
import React from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {IDefaultModalOpenerFormListProps} from 'components/report-configuration/report-configuration.types';
import {SwitchFormatSettingsModalContent} from 'components/report-configuration/tabs/report-table-settings/modals/switch-format-settings-modal-opener/switch-format-settings-modal-content';
import {ReactComponent as SquareInnerX} from 'shared/assets/square-inner-x.svg';

export const SwitchFormatSettingsModalOpener = ({
    form,
    name,
    disabled,
}: IDefaultModalOpenerFormListProps) => (
    <ModalOpenerComponent
        controlLabels={{
            save: 'Подтвердить',
        }}
        handleCancel={setIsModalOpen => {
            setIsModalOpen(false);
        }}
        handleSave={setIsModalOpen => {
            form.validateFields();
            setIsModalOpen(false);
        }}
        component={(
            <Button
                type="primary"
                className={cn('button-only-icon')}
                disabled={disabled}
            >
                <SquareInnerX className={cn('path-stroke-change-color')} />
            </Button>
        )}
        modalProps={{
            forceRender: false,
            destroyOnClose: true,
            centered: true,
            title: 'Правила форматирования пользовательского значения',
        }}
    >
        <SwitchFormatSettingsModalContent
            form={form}
            name={name}
            disabled={disabled}
        />
    </ModalOpenerComponent>
);
